__turbopack_context__.v({
  "authorAvatar": "Testimonials-module__ItA9Ha__authorAvatar",
  "authorInfo": "Testimonials-module__ItA9Ha__authorInfo",
  "authorName": "Testimonials-module__ItA9Ha__authorName",
  "authorRole": "Testimonials-module__ItA9Ha__authorRole",
  "authorText": "Testimonials-module__ItA9Ha__authorText",
  "carouselContainer": "Testimonials-module__ItA9Ha__carouselContainer",
  "carouselNav": "Testimonials-module__ItA9Ha__carouselNav",
  "carouselWrapper": "Testimonials-module__ItA9Ha__carouselWrapper",
  "container": "Testimonials-module__ItA9Ha__container",
  "dot": "Testimonials-module__ItA9Ha__dot",
  "dotActive": "Testimonials-module__ItA9Ha__dotActive",
  "dots": "Testimonials-module__ItA9Ha__dots",
  "marquee": "Testimonials-module__ItA9Ha__marquee",
  "marqueeContainer": "Testimonials-module__ItA9Ha__marqueeContainer",
  "marqueeTrack": "Testimonials-module__ItA9Ha__marqueeTrack",
  "navBtn": "Testimonials-module__ItA9Ha__navBtn",
  "partnerLogo": "Testimonials-module__ItA9Ha__partnerLogo",
  "partners": "Testimonials-module__ItA9Ha__partners",
  "partnersLabel": "Testimonials-module__ItA9Ha__partnersLabel",
  "quoteIcon": "Testimonials-module__ItA9Ha__quoteIcon",
  "quoteText": "Testimonials-module__ItA9Ha__quoteText",
  "slide": "Testimonials-module__ItA9Ha__slide",
  "testimonials": "Testimonials-module__ItA9Ha__testimonials",
});
